import axios from 'axios'

// Shared-link pages authorize API calls with the link token (and the password, for
// protected links) in headers. They are kept in memory only and sent only to the API,
// never to absolute URLs such as signed S3 links.
const TOKEN_HEADER = 'X-Link-Token'
const PASSWORD_HEADER = 'X-Link-Password'

let token = null
let password = null

const isApiRequest = config => !/^[a-z]+:\/\//i.test(config.url || '')

axios.interceptors.request.use(config => {
  if (token && isApiRequest(config)) {
    config.headers[TOKEN_HEADER] = token
    if (password) {
      config.headers[PASSWORD_HEADER] = password
    }
  }
  return config
})

export function useSharedLink(linkToken) {
  if (linkToken !== token) {
    password = null
  }
  token = linkToken
}

export function unlockSharedLink(linkPassword) {
  password = linkPassword
}

export function clearSharedLink() {
  token = null
  password = null
}
